import client from "./client";

export async function fetchConsentFormTemplate(facilityId) {
  if (!facilityId) {
    throw new Error("Facility ID is required to load consent form template");
  }

  const data = await client.get(
    "ipd_admission/get_consent_form/",
    { facility_id: facilityId },
    { silent: true }
  );

  const template = data?.consent_form_template;
  if (!template) {
    throw new Error("Consent form template not found");
  }

  return template;
}

export async function uploadConsentForm({ patientId, consoleForm }) {
  const data = await client.post("ipd_admission/upload_consent_form/", {
    patient_id: patientId,
    consent_form: consoleForm,
  });

  if (data?.status === "Failed") {
    throw new Error(data.message || "Consent form upload failed");
  }

  return data;
}
